export default __webpack_public_path__ + "static/media/admin-yard-detail.0861b1da.png";